module.exports = __webpack_public_path__ + "static/media/checkmark.9906c2e4.svg";